export const CargoMindsSmallLogo = ({ className }) => {
    return (
        <svg width="80" height="36" viewBox="0 0 80 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M64.5254 13.6702V7.4428V0H42.1073V7.4428V13.6702V21.113V28.5558V35.9986H49.5501V28.5558V21.113V13.6702V7.4428H56.9929V13.6702V21.113V28.5558V35.9986H64.5254V28.5558V21.113H71.9682V28.5558V35.9986H79.411V28.5558V21.113V13.6702H64.5254Z"
                fill="#24B98C"
            />
            <path d="M10.4529 13.6715L0.588974 35.9999H36.1889V28.5571H11.9774L15.2952 21.1143H36.1889V13.6715H10.4529Z" fill="#24B98C" />
        </svg>
    );
};
